import styled from 'styled-components';

export const AttestationsContainer = styled.div`
  &:not(:first-child) {
    margin-top: 10px;
    border-top: 1px solid ${({ theme }) => theme.colors.separatorOnWhite};
    padding-top: 10px;
  }

  max-width: 420px;
`;
